<div id="cabecalho" class="container-fluid">
    <fieldset class="panel mb-1">
      <legend>Agenda</legend>
      <hr>
        <div class="row">
            <div class="col-md-4">
                <div class="mb-1">
                    <label for="nroAtd" class="form-label">Descrição da Clínica</label>
                    <input type="text" class="form-control form-control-sm" id="nroAtd" readonly value="{{ especialidade?.descricao_Clinica ?? 'Carregando...' }}">
                </div>
            </div>

            <div class="col-md-8">
                <div class="mb-1">
                    <label for="nomePaciente" class="form-label">Nome do Beneficiário</label>
                    <input type="text" class="form-control form-control-sm" id="nomePaciente" [(ngModel)]="nomePaciente" (keyup.enter)="obterAgenda()">
                </div>
            </div>
        </div>

        <div class="row">

            <div class="col-md-2">
                <div class="mb-1">
                    <label for="dataAtendimento" class="form-label">Data</label>
                    <input type="date" class="form-control form-control-sm" id="dataAtendimento" [(ngModel)]="dataAtendimentoFormatada">
                </div>
            </div>

            <div class="col-md-8">
                <div class="mb-1">
                    <label for="medico" class="form-label">Profissional Executante</label>
                    <input type="text" class="form-control form-control-sm" id="medico" readonly value="{{ this.medico?.nome ?? 'Carregando...' }}">
                </div>
            </div>
        </div>
    </fieldset>

    <fieldset class="panel">
        <legend>Todos Beneficiários Agendados na Data : {{ dataAtendimento | date: 'dd/MM/yyyy' }}</legend>
        <div class="table-responsive">
        <table class="table table-sm table-striped table-hover">
            <thead>
              <tr>
                <th scope="col">Hora</th>
                <th scope="col">Recepção</th>
                <th scope="col">Atendimento</th>
                <th scope="col">Status</th>
                <th scope="col">Obs.</th>
                <th scope="col">Nome do Beneficiário</th>
                <th scope="col">Plano Operadora</th>
                <th scope="col">Nome do Profissional</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let atendimento of atendimentos" [ngClass]="getStatusCor(atendimento)" (click)="selecionouLinha(atendimento)">
                <td>{{ atendimento.hora_Agenda | numeroParaHora }}</td>
                <td>{{ atendimento.hora_Comparecimento | numeroParaHora }}</td>
                <td>{{ atendimento.hora_Realizacao_Consulta | numeroParaHora }}</td>
                <td>{{ atendimento.status }}</td>
                <td>{{ atendimento.observacao | reticencias: 10 }}</td>
                <td>{{ atendimento.beneficiario?.nome_Beneficiario }}</td>
                <td>{{ atendimento?.plano?.descricao_Plano_Operadora ?? 'PARTICULAR' }} </td>
                <td>{{ medico?.nome }}</td>
              </tr>
            </tbody>
          </table>
          </div>
    </fieldset>
</div>
